module.exports = __webpack_public_path__ + "img/twitter - FontAwesome@1x.0eec3439.svg";